<template>
  <v-btn
    :color="powerTripDarkBlue"
    block
    outlined
    :disabled="disabled"
    :loading="loading"
    class="text-none rounded-lg"
    @click="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>
<script lang="ts">
import Vue from "vue";
import { powerTripDarkBlue } from "@/logic/data/const";

export default Vue.extend({
  name: "OutlinedBlockBtn",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      powerTripDarkBlue: powerTripDarkBlue,
    };
  },
  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
});
</script>
